import { Select } from "antd"
import { useEffect, useState } from 'react';
import { getknowledgeGran } from "../../../../controllers/entities";
import { SizeType } from "antd/es/config-provider/SizeContext";


interface Props  {
    onChange: (value : string) => void,
    onClear: () => void,
    size? : SizeType,
    defaultValue? : string,
    style? : any
}

const SelectKnowledgeGran = (props: Props) => {
    const [knowledgeGran, setknowledgeGran] = useState([]);
    useEffect(() => {
        const get_knowledgeGran = async () => {
            const knowledgeGranData = await getknowledgeGran();
            setknowledgeGran(knowledgeGranData.map((knowledgeSpecialtyData: any) => {
                return {
                    value: knowledgeSpecialtyData.id,
                    label: knowledgeSpecialtyData.GRAN_AREA_DE_CONOCIMIENTO
                }
            }));
        }
        get_knowledgeGran();
    }, []);
    
    return (
        <div style={{width : '100%'}}>
            <Select
                {...props}
                labelInValue
                allowClear
                size={props.size}
                defaultValue={props?.defaultValue || []}
                style={props.style}
                onChange={(value:any) => {
                    props.onChange(value);
                }}
                onClear={() => {
                    props.onClear();
                }}
                options={knowledgeGran}
            />        
        </div>
    );
}

export default SelectKnowledgeGran